import type { SVGProps } from 'react';

export function SnowflakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M14 15h-4l-1.5-3L10 9h4l1.5 3z" />
      <path d="M16.106 2.553a1 1 0 0 1 1.788.894l-.856 1.711.783-.141a1 1 0 1 1 .358 1.966l-2.258.41L15.118 9l1 2h1.883l1.2-1.6a1 1 0 1 1 1.599 1.2l-.301.4H22a1 1 0 0 1 0 2h-1.501l.3.4a1 1 0 1 1-1.599 1.2L18.001 13h-1.883l-1 2 .803 1.605 2.258.412a1 1 0 1 1-.358 1.966l-.783-.142.857 1.712a1 1 0 0 1-1.79.894l-.855-1.71-.355.71a1 1 0 0 1-1.79-.894l1.027-2.053-.75-1.5h-2.764l-.75 1.5 1.027 2.053a1 1 0 0 1-1.79.894l-.355-.71-.855 1.71a1 1 0 0 1-1.79-.894l.856-1.712-.782.142a1 1 0 1 1-.358-1.966l2.257-.412L8.882 15l-1-2H5.999l-1.2 1.6A1 1 0 1 1 3.2 13.4l.301-.4H2a1 1 0 1 1 0-2h1.501l-.3-.4A1 1 0 1 1 4.8 9.4L5.999 11h1.883l1-2-.804-1.606-2.257-.41a1 1 0 1 1 .358-1.967l.782.141-.856-1.71a1 1 0 0 1 1.79-.895l.855 1.71.355-.71a1 1 0 0 1 1.79.894L9.868 6.5l.75 1.5h2.764l.75-1.5-1.027-2.053a1 1 0 0 1 1.79-.894l.355.71zM9.618 12l1 2h2.764l1-2-1-2h-2.764z" />
    </svg>
  );
}
